import {gql} from "@apollo/client";
import { setting, settings } from "@core/gql-mockups/settings";

const GET_SETTING_BY_KEY = gql`
  query ($key: String) {
    result: getSettingByKey(key: $key) ${setting}
  }
`;

const GET_SETTINGS_BY_KEYS = gql`
  query ($keys: [String]) {
    result: getSettingByKeys(keys: $keys) ${settings}
  }
`;

const GET_SETTING_WEB_SCRIPT_BY_ID = gql`
  query ($id: ID) {
    result: getSettingWebScriptById(id:$id)
  }
`;

const GET_SETTING_CONFIG = gql`
  query ($service_key: String) {
    result: getSettingConfigByKey(service_key: $service_key)
  }
`;

const GET_CAPTCHA_CONFIG = gql`
  query {
    result: getCaptchaConfig {
      api_endpoint
      places
    }
  }
`;

const GET_SETTING_CONFIG_WITH_WEB_PROJECT = gql`
  query ($service_key: String, $currency_lang: String) {
    config: getSettingConfigByKey(service_key: $service_key)
    web_project: getWebProjectSettings(currency_lang: $currency_lang) {
      currency
    }
  }
`;


export {GET_SETTING_BY_KEY,GET_SETTINGS_BY_KEYS, GET_CAPTCHA_CONFIG, GET_SETTING_WEB_SCRIPT_BY_ID, GET_SETTING_CONFIG, GET_SETTING_CONFIG_WITH_WEB_PROJECT};